import { useEffect, useMemo, useCallback, useState } from 'react';
import { useCookies } from './useCookies';

type UseBannerDismissalReturns = {
    dismissBanner: () => void;
    hasDismissedBanner: boolean;
};
export function useBannerDismissal(bannerId?: number): UseBannerDismissalReturns {
    const { getCookie, setCookie } = useCookies();

    const cookieKey = useMemo(() => (bannerId ? `banner-${bannerId}` : ''), [bannerId]);

    const [hasDismissedBanner, setHasDismissedBanner] = useState(false);

    const currentDomain = `.${window.location.hostname}`;

    useEffect(() => {
        if (cookieKey) {
            const cookieVal = getCookie(cookieKey);
            setHasDismissedBanner(cookieVal === 'true');
        }
    }, [cookieKey, getCookie]);

    const dismissBanner = useCallback(() => {
        if (cookieKey) {
            setCookie(cookieKey, 'true', currentDomain);
            setHasDismissedBanner(true);
        }
    }, [currentDomain, cookieKey, setCookie]);

    return {
        dismissBanner,
        hasDismissedBanner,
    };
}
